import type { PropsWithChildren } from 'react';
import { memo } from 'react';
import { ContextMenuContextProvider } from '@frameio/shared/contexts';
import { DraggableAssetOverlay } from '../asset';
import { GlobalDndContextProvider } from '../operations';

export const FinderProviders = memo(({ children }: PropsWithChildren) => (
  <GlobalDndContextProvider overlay={<DraggableAssetOverlay />}>
    <ContextMenuContextProvider>{children}</ContextMenuContextProvider>
  </GlobalDndContextProvider>
));
